import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoMoeda } from '../models/projeto-moeda.model';

@Injectable()
export class ProjetoMoedaService extends BaseService<ProjetoMoeda> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-moeda';
  }
}
